export class LogsData {
        date: string;
    // food log
        food_name: string = '';
        food_type: string = '';
        food_category: string = '';
        meal_type: string = '';
        measure: string = '';
        portion: string = '';
        foodDate: string = '';
        calories: Number = 0;
    
    // weight log
        weight: string = '';
        BMI: number = 0;
        weightDate: string = '';

    // activity log
        time: string = '';
        activity: string = '';
        activityDate: string = '';
        intensity: string = '';
        activityCalories: Number = 0;

    // health log
        waist: Number = 0;
        glucose: Number = 0;
        bloodhigh: Number = 0;
        bloodlow: Number = 0;
        hdl: Number = 0;
        ldl: Number = 0;
        a1c: Number = 0;
        healthDate: string = '';

    // activity plan
        planactivity: string = '';
        planminutes: string = '';
        activityrealistic: string = '';
        activitydays: string = '';
        activityStatus: string = '';
        activityPlanId: string = '';

        // food plan
        foodplan: string = '';
        plannedTimes: string = '';
        plannedFood: string = '';
        currentTimes: string = '';
        fooddays: string = '';
        days: string[] = [];
        foodStatus: string = '';
        foodPlanId: string = '';

        caloriesreturn: string = "";

        //programs
        code:string = '';
        startdate: string = '';
        enddate: string = '';
        title: string = '';
        coachname: string = '';
        programtime:string='';
        program_id: string='';

        //coach patient
        id: string= "";
        patient: string = "";
        name: string = ''

    }